import React, { useState } from 'react';
import styled from 'styled-components';

import plusImage from "images/plus.svg";
import minusImage from "images/minus.svg";
import { COLOR } from 'constants/colors';

import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';

const AccordionListCont = styled.div``;
const AccordionCont = styled.div`
`;
const AccordionHeader = styled.div`
    display: flex;
    padding: 16px 0;
    justify-content: space-between;
    cursor: pointer;
    .accordion-title {
        flex: 1;
        font-size: 16px;
        line-height: 1.25;
        font-weight: 400;
        padding-right: 15px;
    }
    .accordion-status-icon {
        line-height: 0;
    }
`;
const AccordionContent = styled.div`
    padding: 0 0 20px 0;
    line-height: 1.5;
    b{
        color: ${COLOR.LINK};
        font-weight: 500;
    }
`;
const AccordionImage = styled.img`
    height: 24px;
    width: 24px;
`;

interface AccordianItem {
    title: string,
    content: any
}

interface AccordionProps {
    list: AccordianItem[]
}

const Accordion: React.FC<AccordionProps> = (props: AccordionProps) => {

    const [visible, setVisible] = useState<boolean[]>(props.list.map(() => false));

    const toggle = (indexToChange: number) => {
        setVisible(visible.map((v: boolean, i: number) => i === indexToChange ? !v : v));
        Mixpanel.track(getEventName("Faq" ,"clicked","knowMore"), {
            agentCode: getAgentCode(),
            user: getUserDetails()
        });
    };

    return (<AccordionListCont>
        {props.list.map((acc: AccordianItem, i: number) =>
            <AccordionCont key={i} style={{ borderBottom: ((i < props.list?.length - 1) ? '1px solid lightgrey' : 'none') }}>
                <AccordionHeader onClick={() => toggle(i)}>
                    <div className="accordion-title">{acc.title}</div>
                    <span className='accordion-status-icon '>{visible[i] ? <AccordionImage src={minusImage} /> : <AccordionImage src={plusImage} />}</span>
                </AccordionHeader>
                {visible[i] ? <AccordionContent dangerouslySetInnerHTML={{ __html: acc.content }} /> : null}
            </AccordionCont>)}
    </AccordionListCont>)
}

export default Accordion;